<rma-header-count-button
  [count]="count$ | async"
  classes="hidden sm:flex"
  srSubtitle="agents"
  matIcon="group"
  routerLink="/account/compare-agents" />
